import axios from "axios";

const apiUrl = process.env.VUE_APP_API_URL;

export const  getPrintPhotoData =  async () => {
    try {
        const response = await axios.get(`${apiUrl}/print-photo/data`);
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
};
export const  storePrintPhotoData =  async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/print-photo/order`,data);
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
};

export const  updatePrintPhotoData =  async (id, data) => {
    try {
        const response = await axios.post(`${apiUrl}/print-photo/order/${id}/update`, data);
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
};

export const  getPrintPhotoOrder =  async (id) => {
    try {
        const response = await axios.get(`${apiUrl}/print-photo/order/${id}`);
        return response.data; // اطلاعات سفارش
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
};

export const  getPrintPhotoOrders =  async () => {
    try {
        const response = await axios.get(`${apiUrl}/print-photo/orders`);
        return response.data; // لیست سفارش‌ها
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
};

export const calculatePrintPhotoPrice = async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/print-photo/calc-price`, data);
        return response.data;
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message || 'خطا در محاسبه قیمت'
        };
    }
};

export const  deletePrintPhotoOrder =  async (id) => {
    try {
        const response = await axios.delete(`${apiUrl}/print-photo/order/${id}`);
        return response.data; // نتیجه حذف
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
};

// Photo upload functions
export const uploadPrintPhotoFile = async (orderId, file, number = 1, onProgress = null) => {
    try {
        // Ensure we have a File object
        let fileToUpload = file;
        
        if (!(fileToUpload instanceof File)) {
            console.error('File is not a File instance!');
            return {
                success: false,
                message: 'فایل نامعتبر است'
            };
        }
        
        const formData = new FormData();
        formData.append('order_id', orderId);
        formData.append('file', fileToUpload);
        formData.append('number', number.toString());
        
        // Debug: Check FormData contents
        // for (let pair of formData.entries()) {
        //     if (pair[0] === 'file') {
        //         console.log('FormData:', pair[0], '=', 'File:', pair[1].name, 'Size:', pair[1].size, 'Type:', pair[1].type);
        //     } else {
        //         console.log('FormData:', pair[0], '=', pair[1]);
        //     }
        // }
        // console.log('=== Upload Debug End ===');
        
        const config = {
            // Don't set Content-Type for FormData - let the browser set it with the boundary
            headers: {
                'Accept': 'application/json'
            }
        };

        // Add progress tracking if callback provided
        if (onProgress) {
            config.onUploadProgress = (progressEvent) => {
                const progress = {
                    loaded: progressEvent.loaded,
                    total: progressEvent.total || fileToUpload.size
                };
                onProgress(progress);
            };
        }

        const response = await axios.post(`${apiUrl}/print-photo/upload`, formData, config);
        return response.data;
    } catch (error) {
        console.error('Upload error:', error);
        return {
            success: false,
            message: error.response?.data?.message || 'خطا در آپلود فایل'
        };
    }
};

export const getPrintPhotoFiles = async (orderId) => {
    try {
        const response = await axios.get(`${apiUrl}/print-photo/${orderId}/files`);
        return response.data;
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message || 'خطا در دریافت فایل‌ها'
        };
    }
};

export const updatePrintPhotoFile = async (fileId, data) => {
    try {
        console.info('160 data', data);
        const formData = new FormData();
        if (data.name) formData.append('name', data.name);
        if (data.number) formData.append('number', data.number);
        if (data.file) formData.append('file', data.file);
        formData.append('file_id', fileId);

        const response = await axios.post(`${apiUrl}/print-photo/update-file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message || 'خطا در بروزرسانی فایل'
        };
    }
};

export const deletePrintPhotoFile = async (fileId) => {
    try {
        const formData = new FormData();
        formData.append('file_id', fileId);

        const response = await axios.post(`${apiUrl}/print-photo/delete_file`, formData);
        return response.data;
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message || 'خطا در حذف فایل'
        };
    }
};